import { makeAutoObservable, runInAction } from 'mobx'
import firestore from '~/modules/firestore'

class Config {
  cd: PromoConfig = { promo: false, promo_interest: false, interest: 0 }
  re: PromoConfig = { promo: false, promo_interest: false, interest: 0 }
  saving: PromoConfig = { promo: false, promo_interest: false, interest: 0 }
  mf: PromoConfig = { promo: false, promo_interest: false, interest: 0 }

  constructor() {
    makeAutoObservable(this)
    this.init()
  }

  init() {
    firestore
      .collection('configs')
      .onSnapshot((snapshot) => {
        snapshot.forEach((documentSnapshot) => {
          runInAction(() => {
            switch (documentSnapshot.id) {
              case 'saving':
                this.saving = documentSnapshot.data() as PromoConfig
                break
              case 'cd':
                this.cd = documentSnapshot.data() as PromoConfig
                break
              case 're':
                this.re = documentSnapshot.data() as PromoConfig
                break
              case 'mf':
                this.mf = documentSnapshot.data() as PromoConfig
                break
            }
          })
        })
      })
  }
}

const config = new Config()
export default config
